module.exports = __webpack_public_path__ + "static/img/children.82d7fd03.png";